import React from "react";
import styled from "styled-components";
import PageWrapper from "../components/PageWrapper";
import Seo from "../components/Seo";
import SlackRequestForm from "../sections/community/SlackRequestForm";

const Page = styled.main`
  background: var(--nd-black);
  min-height: 100vh;
  padding: 160px 24px 128px;
  @media (max-width: 768px) { padding: 120px 16px 96px; }
`;

const Inner = styled.div`
  max-width: 720px;
  margin: 0 auto;
`;

const Kicker = styled.div`
  font-family: 'Space Mono', monospace;
  font-size: 10px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--nd-text-disabled);
  margin-bottom: 16px;
`;

const Title = styled.h1`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 56px;
  font-weight: 500;
  color: var(--nd-text-display);
  letter-spacing: -0.02em;
  margin: 0 0 24px;
  line-height: 1.05;
  @media (max-width: 768px) { font-size: 40px; }
`;

const Intro = styled.p`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 18px;
  line-height: 1.6;
  color: var(--nd-text-primary);
  max-width: 60ch;
  margin: 0 0 64px;
`;

const SlackPage = () => (
  <PageWrapper>
    <Seo
      title="Join the Dioscuro Slack — free"
      description="Our Slack is where the team, clients, mentors, and academy engineers hang out. Free. Drop your details for an invite."
    />
    <Page>
      <Inner>
        <Kicker>COMMUNITY · FREE</Kicker>
        <Title>Want to join?</Title>
        <Intro>
          Our Slack is where the team, clients, mentors, and academy engineers
          hang out. Engineering questions, ship notes, war stories, the
          occasional job lead. Free. Drop your details below and I'll send you
          an invite within 48 hours.
        </Intro>
        <SlackRequestForm />
      </Inner>
    </Page>
  </PageWrapper>
);

export default SlackPage;
